import React from "react";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

import "./AppAwardsAccoladesOverviewWidget.css";

import BfsiAwards from "../../../images/about-us/awards/BFSI-2020.png";
import IAMAIAwards from "../../../images/about-us/awards/IAMAI-India-Digital-Awards-2020.png";
import IndiaRetailAwards from "../../../images/about-us/awards/India-Retail-e-retail-awards-2019.png";
import IndIAAAwards from "../../../images/about-us/awards/IndIAA-Awards-2018.png";

const AppAwardsAccoladesOverviewWidget = () => (
    <WidgetContainer>
        <div className="awa-acc-container">
            <h2>
                Awards &amp; <br /> Accolades
            </h2>
            <div className="awa-acc-container__content">
                <div className="awa-acc-container__content__item">
                    <p className="awards-logo">
                        <img src={BfsiAwards} alt="Exhibit Awards" />
                    </p>
                    <h3 className="h-space">Excellence in WealthTech</h3>
                    <p className="h-space">
                        Third ET BFSI Innovation Tribe Virtual Summit &amp;
                        Awards (APAC edition)
                    </p>
                </div>
                <div className="awa-acc-container__content__item">
                    <p className="awards-logo">
                        <img src={IndIAAAwards} alt="IndiaRetail Awards" />
                    </p>
                    <h3>
                        Telecom &amp; <br /> Technology
                    </h3>
                    <p>
                        Best campaign under the <br />
                        Telecom &amp; Technology category <br />
                        at the IndIAA Awards 2018
                    </p>
                </div>
                <div className="awa-acc-container__content__item">
                    <p className="awards-logo">
                        <img src={IndiaRetailAwards} alt="IndIAA Awards" />
                    </p>
                    <h3>
                        India Retail <br />
                        and e- Retail
                    </h3>
                    <p>
                        PhonePe announced as a <br />
                        winner at 8th Annual India <br />
                        Retail and e- Retail Awards 2019
                    </p>
                </div>
                <div className="awa-acc-container__content__item">
                    <p className="awards-logo">
                        <img src={IAMAIAwards} alt="IAMAI Awards" />
                    </p>
                    <h3 className="h-space">
                        IAMAI Digital <br />
                        Award 2019
                    </h3>
                    <p className="h-space">
                        IAMAI 9th India Digital <br />
                        Awards 2019
                    </p>
                </div>
            </div>
        </div>
    </WidgetContainer>
);

export default AppAwardsAccoladesOverviewWidget;
